export default "__VITE_ASSET__9gXT6yCT__"